export const BADGE_COLORS = {
  black: 'black',
  blue: 'blue',
  red: 'red',
  orange: 'orange',
  green: 'green',
  purple: 'purple'
};

export const BADGE_STATUS_COLOR = {
  outstanding: 'blue',
  live: 'blue',
  'in progress': 'blue',
  updated: 'blue',
  overdue: 'red',
  expired: 'red',
  rejected: 'red',
  inactive: 'red',
  deprecated: 'red',
  pending: 'orange',
  'tds pending': 'orange',
  'tds validation': 'orange',
  'under review': 'orange',
  ready: 'green',
  paid: 'green',
  closed: 'green',
  completed: 'green',
  invited: 'green',
  active: 'green',
  admin: 'purple',
  guest: 'purple',
  monitor: 'purple',
  'sub-admin': 'purple',
  trader: 'purple',
  open: 'black',
  'not aplicable': 'black'
};



// WEBPACK FOOTER //
// ./src/uis/elements/Badges/constants.js